import React from 'react';
import { FadeIn } from './FadeIn';
export function CTA() {
  return <section id="cta" className="py-[120px] px-[5%] bg-gris-oscuro text-center relative overflow-hidden" data-id="element-10">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_50%_50%,rgba(26,79,219,0.12)_0%,transparent_70%)]" data-id="element-11"></div>

      <FadeIn className="relative z-10 max-w-[700px] mx-auto" data-id="element-12">
        <h2 className="font-rajdhani text-[clamp(36px,5vw,64px)] font-bold leading-[1.1] mb-[20px]" data-id="element-13">
          ¿Tu Auto Necesita
          <br data-id="element-14" />
          <span className="text-acento" data-id="element-15">Atención Profesional?</span>
        </h2>
        <p className="text-texto-gris text-[17px] leading-[1.7] mb-[44px]" data-id="element-16">
          No esperes a que un problema pequeño se convierta en uno grande.
          Contactanos hoy y agendá tu turno con los especialistas de San Luis.
        </p>

        <div className="flex gap-[16px] justify-center flex-wrap flex-col sm:flex-row items-center" data-id="element-17">
          <a href="https://wa.me/5492664261245" target="_blank" rel="noreferrer" className="inline-flex items-center gap-[10px] bg-gradient-primary text-blanco px-[32px] py-[16px] rounded-[10px] no-underline font-semibold text-[15px] tracking-[0.3px] border border-azul-neon/50 transition-all duration-300 shadow-[0_4px_25px_rgba(37,99,235,0.3)] hover:-translate-y-[2px] hover:shadow-[0_8px_35px_rgba(37,99,235,0.5)] hover:bg-gradient-hover w-full sm:w-auto justify-center" data-id="element-18">
            <i className="fab fa-whatsapp" data-id="element-19"></i>
            Pedir Turno por WhatsApp
          </a>
          <a href="https://www.google.com/maps/dir/?api=1&destination=Maipú+766,+San+Luis,+Argentina" target="_blank" rel="noreferrer" className="inline-flex items-center gap-[10px] bg-transparent text-blanco px-[32px] py-[16px] rounded-[10px] no-underline font-medium text-[15px] border border-white/20 transition-all duration-300 hover:bg-white/5 hover:border-white/40 w-full sm:w-auto justify-center" data-id="element-20">
            <i className="fas fa-map-marker-alt" data-id="element-21"></i>
            Cómo Llegar
          </a>
        </div>
      </FadeIn>
    </section>;
}